<template>
  <div style="width: 600px">
    <el-form label-width="100px" :model="formData">
      <el-form-item :label="$t('lang.做法介绍')">
        <nation-input
            :list="supportLangList"
            :placeholder="$t('lang.点击下方自动生成食谱总步骤后，即使不在此输入，此处内容也会在下一项内容完成后自动生成')"
            type="textarea"
            :rows="10"
            :lang="lang"
            v-model="formData.introduction"
            :disabled="disabled" />
      </el-form-item>

      <el-form-item v-if="!disabled">
        <el-checkbox v-model="formData.autoCreateStepDesc">{{$t('lang.按步骤自动生成')}}</el-checkbox>
      </el-form-item>


      <el-form-item :label="$t('lang.厨师建议')">
        <nation-input
            :list="supportLangList"
            type="textarea"
            :placeholder="$t('lang.如果未知可以跳过')"
            :rows="5"
            :lang="lang"
            v-model="formData.chefRec"
            :disabled="disabled" />
      </el-form-item>

      <el-form-item>
        <el-button @click="$router.back()" v-if="disabled">{{$t('lang.返回')}}</el-button>
        <template v-else>
          <el-button @click="$emit('save')">{{ $t('lang.保存') }}</el-button>
          <el-button v-if="$store.getters.hasTranslate" @click="$emit('translate')">{{$t('lang.翻译')}}</el-button>
        </template>
        <el-button type="primary" @click="$emit('lastStep')">{{$t('lang.上一步')}}</el-button>
        <el-button type="primary" @click="$emit('next')">{{$t('lang.下一步')}}</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import NationInput from "../nation/NationInput";
export default {
  name: "IntroductionForm",
  components: {NationInput},
  props: {
    recipeData: {
      type: Object,
      default() {
        return {};
      }
    },
    status: {
      type: String,
      default: 'add'
    }
  },
  data() {
    return {
      formData: {
        autoCreateStepDesc: false,
        introduction: {},
        chefRec: {},
      },
      disabled: false,
      recipeLang: {}
    }
  },
  activated() {
    this.$nextTick(() => {
      this.handleGetData();
    })
  },
  created() {
    this.$bus.$on("translateRecipe", () => {
      this.handleGetData();
    });
  },
  methods: {
    handleGetData() {
      let {recipeLang, autoCreateStepDesc} = this.$store.state.recipe;
      console.log('获取到参数', recipeLang)
      this.recipeLang = recipeLang;
      for (const key in recipeLang) {
        this.$set(this.formData.introduction, key, recipeLang[key].introduction);
        this.$set(this.formData.chefRec, key, recipeLang[key].chefRec);
      }
      if(autoCreateStepDesc && autoCreateStepDesc === "1") {
        this.formData.autoCreateStepDesc = true;
      }
    },

    // 处理提交数据
    handleFormatData() {
      let recipeLang = this.recipeLang;
      for (const key in recipeLang) {
        recipeLang[key].introduction = this.formData.introduction[key];
        recipeLang[key].chefRec = this.formData.chefRec[key];
      }
      return recipeLang;
    }
  },
  computed: {
    supportLangList() {
      return this.$store.state.recipe.supportLangList;
    },
    lang() {
      return this.$store.state.recipe.lang;
    }
  },
  watch: {
    formData: {
      handler() {
        let recipeLang = this.handleFormatData();
        const autoCreateStepDesc = this.formData.autoCreateStepDesc ? "1" : "0";
        this.$store.commit('CHANGE_RECIPE', {recipeLang, autoCreateStepDesc});
      },
      immediate: false,
      deep: true,
    },
    status: {
      handler(state) {
        if(state == 'detail') {
          this.disabled = true;
        }
      },
      immediate: true,
      deep: true,
    }
  },
}
</script>

<style scoped>

</style>
